// extracted by mini-css-extract-plugin
module.exports = {"container":"_2q-h5","title":"_2-zsz","postsList":"_1NX1m","postListItem":"_3LSfO"};